module.exports = __webpack_public_path__ + "img/Progress.0aa07d54.svg";